<template>
  <v-container fluid class="wrapper ma-0 pa-0">
    <v-row class="row-wrapper">
      <v-col>
        <h1>Forbidden</h1>
        <h4>You are not authorized to view this content</h4>
        <p><v-btn @click="goToDashboard">Go to dashboard</v-btn></p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: '403Forbidden',
  methods: {
    goToDashboard() {
      this.$router.replace({ path: '/communitydashboard'})
    }
  }
}

</script>

<style scoped>
.wrapper {
  height: 100%;
  overflow: hidden;
  background-color: #282B24;
  color: #F1EEDB;
  justify-content: center;
  align-items: center;
  display: flex;
  text-align: center;
}

.wrapper h1 {
  font-size: calc(4rem + 2vw);
	text-transform: uppercase;
}

.wrapper h4 {
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  font-size: 2rem;
  margin: 1.5rem 0 3rem;
}
</style>